import { render, staticRenderFns } from "./CarouselLazyLoading.vue?vue&type=template&id=d2bb600e&scoped=true&"
import script from "./CarouselLazyLoading.vue?vue&type=script&lang=js&"
export * from "./CarouselLazyLoading.vue?vue&type=script&lang=js&"
import style0 from "./CarouselLazyLoading.vue?vue&type=style&index=0&id=d2bb600e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb600e",
  null
  
)

export default component.exports